import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchSocialAccount } from "services/api/social-account";
import { AuthState } from "slices/auth/reducer";
import { SocialAccount } from "types/influencer";
import { SocialAccountState } from "types/social-account";
import { getErrorMessage, isFresh } from "utils/helpers";

export const fetchSocialAccountThunk = createAsyncThunk<{socialAccountId: string, socialAccount: SocialAccount, cached?: boolean}, {socialAccountId: string, force?: boolean}, {rejectValue: string}>(
    'influencer/social-account',
    async ({socialAccountId, force=false}, {getState, rejectWithValue}) => {
        try {
            const state = getState() as {auth: AuthState, socialAccountState: SocialAccountState};
            const STALE_TIME = apiConfig.FETCH_SOCIAL_ACCOUNT.staleTime;

            if(!force && isFresh(state.socialAccountState.items?.[socialAccountId]?.last_fetched_at ?? null, STALE_TIME)){
                return {socialAccountId, socialAccount: state.socialAccountState.items?.[socialAccountId].account, cached: true}
            }


            const agencyId = state.auth.selectedAgencyId ?? '';
            if(!agencyId) throw new Error("No agency id selected!");
            const {social_account} = await fetchSocialAccount(agencyId, socialAccountId);

            return {socialAccountId, socialAccount: social_account}

        } catch (error) {
            return rejectWithValue(getErrorMessage(error, 'failed to fetch social account'));
        }
    }
)